<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="8">
        Get Country Info From the IP Address(GEO-IP)
      </b-col>
      <b-col sm="3" class="text-left">
        <c-switch color="success" label variant="pill" size="sm" defaultChecked v-model="use_geoip" @change="change_use_geoip"/>
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain_modal = true"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4">
        Please select the country where firewall mode is applied.
      </b-col>
      <b-col sm="6">
        <b-form-input :disabled="!use_geoip" style="display:inline-block" v-model="country" placeholder="Enter Country name"></b-form-input>
      </b-col>
      <b-col sm="2" class="text-left">
        <b-form-checkbox :disabled="!use_geoip" v-model="select_all" @change="toggle_all">
          Select All
        </b-form-checkbox>
        <b-form-checkbox :disabled="!use_geoip" v-model="show_block_only" @change="save_show_status">
          Only Selected
        </b-form-checkbox>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4">
        Selected Country
      </b-col>
      <b-col sm="8">
        {{country_code.length}}
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="12">
        <div class="pr-2 pl-2" v-show="(is_show(x) && !show_block_only) || (show_block_only && x.is_block)" v-for="(x, index) in country_info" style="min-width:75px; height:75px; display:inline-block;">
          <b-form-checkbox :disabled="!use_geoip" style="cursor:pointer;" v-model="x.is_block" class="is_check" @change="onSelect(x.Code, x.Name)">
            <CountryFlag class="explain" style="cursor:pointer;"  :country="x.Code" size='normal'/>
            <p :style="x.is_block ? 'font-weight:900' : ''">{{ country ? x.Name : x.Code}}</p>
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="Block Base Country Code"  class="modal-info" v-model="explain_modal" ok-variant="success" header-bg-variant="success" ok-only>
      <p>For country code blocking, you must use the GEO-IP function to convert IP to country</p>
      <p>123.123.123.123 	&rArr; KR  </p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
